/*
 *
 * ControlPanel constants
 *
 */

export const DEFAULT_ACTION = "app/ControlPanel/DEFAULT_ACTION"
